export default __webpack_public_path__ + "static/media/sandreal.60e7f98e.png";